<template>
  <v-text-field
    :value="value"
    @input="$emit('input', $event || null)"
    :label="label"
    :disabled="disabled"
    :rules="rules.image"
  >
    <template
      slot="append-outer"
      v-if="!hideUploadWhenDisabled || !disabled"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            icon
            small
            v-on="on"
            @click="uploadImage()"
            :disabled="disabled"
          >
            <v-icon>cloud_upload</v-icon>
          </v-btn>
        </template>

        <span>Upload image</span>
      </v-tooltip>

      <input
        type="file"
        :ref="ref"
        style="display: none;"
        @change="onFileChange()"
      />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'TextFieldImage',
  props: {
    value: { // v-model binding
      type: String
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    hideUploadWhenDisabled: {
      type: Boolean
    }
  },
  data() {
    return {
      ref: `${this.name}Input`,
      rules: {
        image: [
          v => !v || /https?:\/\/.+/.test(v) || 'Image must be valid'
        ]
      }
    }
  },
  methods: {
    uploadImage() {
      this.$refs[this.ref].click()
    },
    async onFileChange() {
      const file = this.$refs[this.ref].files[0]
      if (!file) return

      const value = await this.$s3Upload(file)
      this.$emit('input', value || null)
    }
  }
}
</script>
